import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  ETimeBucketType,
  EReportingTimeWindow,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDAPositionsReportChartFilters,
  TPPAdvertiserId,
} from '../models/types'
import { IDAReportingPositionsChartResponse } from '../models'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetAdvertiserReportingDAPositionsChartV3({
  advertiserId,
  retailerId,
  campaignId,
  adGroupId,
  timeWindow,
  startDate,
  endDate,
  tzZone,
  aggregationType,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & TDAPositionsReportChartFilters &
  TPPAdvertiserId): UseQueryResult<
  AxiosResponse<IDAReportingPositionsChartResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getAdvertiserReportingDAPositionsChart_${advertiserId}_${retailerId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate }],
    () => {
      return coreAPIV3.advertiserReporting().getAdvertiserPositionsReportChart(
        advertiserId,
        generateCorrelationId(),
        retailerId,
        campaignId,
        adGroupId,
        timeWindow as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        aggregationType as ETimeBucketType,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status
      )
    },
    { suspense, enabled }
  )
}
